/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Select_User_AriaInputs */

const en_team_manager_select_user_aria = /** @type {(inputs: Team_Manager_Select_User_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select user to manage`)
};

const fr_team_manager_select_user_aria = /** @type {(inputs: Team_Manager_Select_User_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner l’utilisateur à gérer`)
};

const de_team_manager_select_user_aria = /** @type {(inputs: Team_Manager_Select_User_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie den zu verwaltenden Benutzer aus.`)
};

const it_team_manager_select_user_aria = /** @type {(inputs: Team_Manager_Select_User_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona l'utente da gestire`)
};

const ru_team_manager_select_user_aria = /** @type {(inputs: Team_Manager_Select_User_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите пользователя для управления`)
};

const es_team_manager_select_user_aria = /** @type {(inputs: Team_Manager_Select_User_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione el usuario a administrar`)
};

const zh_cn2_team_manager_select_user_aria = /** @type {(inputs: Team_Manager_Select_User_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择要管理的用户`)
};

const ja_team_manager_select_user_aria = /** @type {(inputs: Team_Manager_Select_User_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理するユーザーを選択`)
};

const hi_team_manager_select_user_aria = /** @type {(inputs: Team_Manager_Select_User_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रबंधित करने के लिए उपयोगकर्ता का चयन करें`)
};

const pt_pt2_team_manager_select_user_aria = /** @type {(inputs: Team_Manager_Select_User_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o usuário a ser gerenciado`)
};

/**
* | output |
* | --- |
* | "Select user to manage" |
*
* @param {Team_Manager_Select_User_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_select_user_aria = /** @type {((inputs?: Team_Manager_Select_User_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Select_User_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_select_user_aria(inputs)
	if (locale === "de") return de_team_manager_select_user_aria(inputs)
	if (locale === "it") return it_team_manager_select_user_aria(inputs)
	if (locale === "ru") return ru_team_manager_select_user_aria(inputs)
	if (locale === "es") return es_team_manager_select_user_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_select_user_aria(inputs)
	if (locale === "ja") return ja_team_manager_select_user_aria(inputs)
	if (locale === "hi") return hi_team_manager_select_user_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_select_user_aria(inputs)
	return en_team_manager_select_user_aria(inputs)
});